import { Button, Panel, Typography } from "@/components/atoms";

interface CancelSubscriptionSectionProps {
  onCancelClick: () => void;
}

export const CancelSubscriptionSection = ({ onCancelClick }: CancelSubscriptionSectionProps) => {
  return (
    <Panel className="flex flex-row items-center justify-between">
      <div className="flex flex-col gap-2">
        <Typography variant="title">Cancel Subscription</Typography>
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          Stopping your subscription will end access to RideMinder on your next billing date. You&apos;ll still have full access until then.
        </Typography>
      </div>
      <Button variant="secondary" size="sm" onClick={onCancelClick}>
        Cancel Subscription
      </Button>
    </Panel>
  );
};
